/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Organizationname2Inputs */

const zh_organizationsettings_organizationname2 = /** @type {(inputs: Organizationsettings_Organizationname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织名称`)
};

const en_organizationsettings_organizationname2 = /** @type {(inputs: Organizationsettings_Organizationname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization Name`)
};

const es_organizationsettings_organizationname2 = /** @type {(inputs: Organizationsettings_Organizationname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la organización`)
};

/**
* | output |
* | --- |
* | "Organization Name" |
*
* @param {Organizationsettings_Organizationname2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_organizationname2 = /** @type {((inputs?: Organizationsettings_Organizationname2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Organizationname2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_organizationname2(inputs)
	if (locale === "en") return en_organizationsettings_organizationname2(inputs)
	return es_organizationsettings_organizationname2(inputs)
});
export { organizationsettings_organizationname2 as "organizationSettings_organizationName" }